import React, { FC } from 'react';
import Form from 'react-bootstrap/Form';
import TextField from '@mui/material/TextField';
import { Input, InputLabel, FormControl } from '@mui/material';
// import { DateTimePicker } from '@mui/x-date-pickers/DateTimePicker';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";

interface IInputDatePicker {
  controlId: string;
  label: string;
  placeholder: string;
  handleChange: any;
  handleBlur?: any;
  errorsField?: any;
  touched?: any
  value: any,
  autofocus?: any,
  readOnly?: any
  disabled?: any

}


/**
 * Input Type Text Reusable Component
 *
 * @param {{ controlId: any; label: any; placeholder: any; handleChange: any; handleBlur: any; errorsField: any; touched: any; }} {
    controlId, label, placeholder, handleChange, handleBlur, errorsField, touched, readOnly, disabled
}
 * @returns {*}
 */
const InputDatePicker: FC<IInputDatePicker> = ({
  controlId, label, placeholder, handleChange, handleBlur, errorsField, touched, value, autofocus, readOnly, disabled
}) => {
  return (
    <>
      {/*<DateTimePicker
          label={label}
          value={value}
          onChange={handleChange}
          // placeholderText={placeholder}
          defaultValue={value}
          error={errorsField && touched }
          helperText={errorsField && touched?errorsField:""}
          name={controlId}
          // readOnly={readOnly}
          // disabled={disabled}
          inputProps={{
            readOnly: Boolean(readOnly),
            disabled: Boolean(disabled),
          }}
        />*/}
      <DatePicker
        name={controlId}
        selected={(value && new Date(value)) || null}
        // defaultValue={value}
        // value={value}
        onChange={handleChange}
        // locale="en-GB"
        placeholderText={placeholder}
        dateFormat="MM-d-yyyy"
      // onBlur={handleBlur}
      // minDate={new Date()}
      />


    </>
  );
}

export default InputDatePicker